/**
 * Where an action item's source meeting opens, with that item singled out.
 *
 * The meeting page already seeds its tab from `?tab=` and highlights the item
 * named by `?actionItemId=` (the same shape `notificationHref` builds for a
 * notification), so landing here puts the reader on the Actions tab with the
 * item in view and its timecode one click from playing.
 */
export function meetingActionItemHref(meetingId: string, actionItemId: string): string {
  return (
    `/meetings/${encodeURIComponent(meetingId)}` +
    `?tab=actions&actionItemId=${encodeURIComponent(actionItemId)}`
  )
}
